import React from "react";
import ApproveButton from "@components/FlowActionButtons/ApproveButton";
import type { GatepassFlowData } from "./ClaimGatepass";
import { canUserApprove } from "./utils";

interface ApproveGatepassProps {
  gatepassFlowData?: GatepassFlowData;
  openDrawer: (drawerName: string) => void;
}

const LANG_BASE = "gatepass";

const ApproveGatepass: React.FC<ApproveGatepassProps> = ({ gatepassFlowData, openDrawer }) => {
  if (!gatepassFlowData?.task) {
    return null;
  }

  const isActionAvailable = Boolean(
    canUserApprove(
      gatepassFlowData.task.status,
      gatepassFlowData.task.claimOwnerName,
      gatepassFlowData.status,
      gatepassFlowData.task.role,
    ),
  );

  const handleApproveClick = () => {
    openDrawer("approveDrawer");
  };

  return (
    <ApproveButton
      langBase={LANG_BASE}
      permission="canApproveGatepass"
      isActionAvailable={isActionAvailable}
      onApprove={handleApproveClick}
    />
  );
};

export default ApproveGatepass;
